export const round = (value, precision) => {
  const multiplier = 10 ** (precision || 0);
  return Math.round(value * multiplier) / multiplier;
};

export const snapAdjusted = (value, snapUnit, method = "round") =>
  Math[method](value / snapUnit) * snapUnit;
